// extracted by mini-css-extract-plugin
export default {"video":"music-shared_video__YQT94"};